"use client";

const transactionAreas = [{
  number: "01",
  eyebrow: "Purchase Agreements",
  title: "Contract Preparation & Review",
  description: "Careful preparation and review of purchase agreements, closing documents, contingencies, representations, payment terms, and other transaction provisions so that the written documents reflect the parties’ negotiated obligations."
}, {
  number: "02",
  eyebrow: "Leases",
  title: "Commercial & Residential Leasing",
  description: "Drafting and reviewing lease agreements with attention to landlord and tenant obligations, payment terms, use provisions, renewal rights, and other terms that may affect the property or the underlying business relationship."
}, {
  number: "03",
  eyebrow: "Due Diligence",
  title: "Title, Property & Transaction Issues",
  description: "Review of title matters, liens, encumbrances, property-related documents, and other issues that may affect ownership rights or the ability of a transaction to proceed as intended."
}, {
  number: "04",
  eyebrow: "Property Matters",
  title: "Tenant, Condominium & Foreclosure Issues",
  description: "Legal guidance involving tenant matters, condominium and association issues, assessments, and selected foreclosure-related matters where property rights, contractual obligations, or ownership interests require careful review."
}];
export default function ContractsAndTransitions() {
  return;
}